"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDynamicConfig = getDynamicConfig;

var _configService = _interopRequireDefault(require("./configService"));

var _configActionKeys = _interopRequireDefault(require("./configActionKeys"));

function getDynamicConfig(root) {
  return {
    type: _configActionKeys.default.GET_DYNAMIC_CONFIG,
    payload: _configService.default.getDynamicConfig(root)
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/dynamicConfig/configActions.js
// module id = 4402
// module chunks = 25